// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mz3h","col":"styles_col__36Ndm"};